import type { StorefrontAsset } from '@/api/menu-list/storefront-menu-snapshot.types';

type SortableAsset = Pick<StorefrontAsset, 'isMainAsset' | 'sortIndex'>;

export const compareAssets = (a: SortableAsset, b: SortableAsset): number => {
    const mainImageDiff = Number(!!b.isMainAsset) - Number(!!a.isMainAsset);
    if (mainImageDiff !== 0) return mainImageDiff;
    return (a.sortIndex ?? 0) - (b.sortIndex ?? 0);
};

export const getMainAsset = <T extends StorefrontAsset>(assets: T[] | null | undefined): T | null => {
    return (assets ?? []).find((asset) => asset && asset.isMainAsset) ?? (assets ?? [])?.[0] ?? null;
};
